const MenuPermissions = {
  edit: 'menu:edit',
  create: 'menu:create',
  delete: 'menu:delete',
  view: 'menu:view',
}

export default MenuPermissions
